const page_name = 1
export default {
  // page_name##页面名称(1:商品详情页)&&
  // sku_id##商品skuid&&
  // logistics_status##物流模块状态(1:露出物流时效;2:未露出物流时效)
  logistic_click: ({ sku_id, logistics_status }) => ({
    act: 'click',
    params: { cfrom: '179|001|01|077', event_id: '179|001|01|077', page_name, sku_id, logistics_status }
  }),
  logistic_show: ({ sku_id, logistics_status, address }) => ({
    act: 'show',
    params: {
      cfrom: '179|001|02|077',
      event_id: '179|001|02|077',
      page_name,
      sku_id,
      logistics_status,
      address: address
        ? `${address.province},${address.city},${address.area},${address?.detailAddress ? address.detailAddress : ''}`
        : ''
    }
  })
}
